import _environmentUserAgent from "../internals/environment-user-agent";
var exports = {};
var userAgent = _environmentUserAgent;
exports = /ipad|iphone|ipod/i.test(userAgent) && typeof Pebble != "undefined";
export default exports;